import MessageComposerProductCatalog from './MessageComposerProductCatalog';

export default MessageComposerProductCatalog;
